import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "neu-button disabled:pointer-events-none",
  {
    variants: {
      variant: {
        default: "neu-button-primary",
        destructive: "neu-button-dark",
        outline: "neu-button-secondary",
        secondary: "neu-button-secondary",
        ghost: "neu-button-ghost",
        link: "neu-button-plain",
      },
      size: {
        default: "neu-button-md",
        sm: "neu-button-compact",
        lg: "neu-button-lg",
        icon: "neu-button-icon",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
Button.displayName = "Button"

export { Button, buttonVariants }
